import { createResourceListQuery } from "queries";
import types from "resources/types";

export const firmTypesQuery = () =>
  createResourceListQuery(types.FIRM_TYPES, {
    url: "/api/v2/firm_types/",
  });
